define('app/models/forgot_password',['app/setup'], function(takhfifan) {
  takhfifan.forgotPassword = Backbone.Model.extend({
      validation: {
        'email': [{
            required: true,
            msg: i18n.t('email_missing')
          }, {
            pattern: 'email',
            msg: i18n.t('email_invalid')
        }]
      },
      defaults: {
        email: null
      }
  });
});

